import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt, faClock } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { useLanguage } from '../context/LanguageContext';
import { MAPS_URL, PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL, EMAIL, INSTAGRAM_URL } from '../siteInfo';
import './Footer.css';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <img src="/img/logo.webp" alt="" width="56" height="56" loading="lazy" />
            <span>Senegalaise Deco Meuble</span>
          </Link>
          <p>{t('footer_tagline')}</p>
          <div className="social-links">
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="WhatsApp">
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
          </div>
        </div>

        <div className="footer-col">
          <h4>{t('footer_quick_links')}</h4>
          <ul>
            <li><Link to="/">{t('nav_home')}</Link></li>
            <li><Link to="/services">{t('nav_services')}</Link></li>
            <li><Link to="/gallery">{t('nav_gallery')}</Link></li>
            <li><Link to="/about">{t('nav_about')}</Link></li>
            <li><Link to="/contact">{t('nav_contact')}</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>{t('nav_services')}</h4>
          <ul>
            <li><Link to="/services">{t('service1_title')}</Link></li>
            <li><Link to="/services">{t('service2_title')}</Link></li>
            <li><Link to="/services">{t('service3_title')}</Link></li>
            <li><Link to="/services">{t('service4_title')}</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>{t('footer_contact_info')}</h4>
          <ul className="footer-contact">
            <li>
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              <a href={MAPS_URL} target="_blank" rel="noopener noreferrer">KM1 Route de Joal, Mbour, Sénégal</a>
            </li>
            <li>
              <FontAwesomeIcon icon={faPhone} />
              <a href={PHONE_TEL}>{PHONE_DISPLAY}</a>
            </li>
            <li>
              <FontAwesomeIcon icon={faEnvelope} />
              <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
            </li>
            <li>
              <FontAwesomeIcon icon={faClock} />
              <span>{t('contact_hours_weekday')}<br />{t('contact_hours_saturday')}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Senegalaise Deco Meuble. {t('footer_rights')}</p>
        <p>{t('footer_made_in')}</p>
      </div>
    </footer>
  );
};

export default Footer;
